
import { helperFunctions } from "./helper";
import { IPermission, IUserGroup } from "../models/IUserGroups.model";

export const tokenHelperFunctions = {
  getJWT(access_token?:string) {
    let token = helperFunctions.getLOLToken();
    let jwt;
    if (token || access_token) {
      const tokenStr= token ?? access_token ?? '';
      jwt = JSON.parse(atob(tokenStr.split(".")[1]));
    }
    return jwt;
  },

  getTokenExpiryTime() {
    return this.getJWT()?.exp && this.getJWT()?.exp * 1000;
  },

  isTokenValid() {
    let currentDateTime = Date.now();
    return this.getTokenExpiryTime() > currentDateTime;
  },

  getLoggedInUserName() {
    const jwtDetails = this.getJWT();
    if (jwtDetails) {
      const firstName = jwtDetails?.fname || "";
      const lastName = jwtDetails?.lname || "";
      return `${firstName} ${lastName}`;
    }
    return "";
  },

  getLoggedInUserInitials() {
    const jwtDetails = this.getJWT();
    if (jwtDetails) {
      const firstName = jwtDetails?.fname?.[0] || "";
      const lastName = jwtDetails?.lname?.[0] || "";
      return `${firstName}${lastName}`;
    }
    return "";
  },
};
